import { Divider, Group } from '@mantine/core'
import cn from 'classnames'

import { CopyUrlButton, ToolbarButton } from './ToolbarButton'
import { ToolbarButtonGroup } from './ToolbarButtonGroup'
import { ToolbarEditorButton } from './ToolbarEditorButton'
import { ToolbarMarkButton } from './ToolbarMarkButton'
import { ToolbarTabs } from './ToolbarTabs'

import styles from './Toolbar.module.css'

export const Toolbar = ({
  children,
  bottomBar,
  className,
}: {
  children: React.ReactNode
  bottomBar?: boolean
  className?: string
}) => {
  return (
    <Group
      className={cn(styles.toolbar, className, {
        [styles.toolbar_bottom]: bottomBar,
      })}
    >
      {children}
    </Group>
  )
}

const ToolbarSection = ({
  position,
  children,
  className,
  bottomBar,
}: {
  position: 'left' | 'right'
  children: React.ReactNode
  className?: string
  bottomBar?: boolean
}) => (
  <Group
    justify={position}
    gap={6}
    className={cn(styles.toolbar___inner, className, {
      [styles.toolbar___right]: position === 'right',
      [styles.toolbar___bottom]: bottomBar,
    })}
  >
    {children}
  </Group>
)

const ToolbarDivider = () => {
  return <Divider orientation="vertical" />
}

Toolbar.Divider = ToolbarDivider
Toolbar.Button = ToolbarButton
Toolbar.EditorButton = ToolbarEditorButton
Toolbar.MarkButton = ToolbarMarkButton
Toolbar.Section = ToolbarSection
Toolbar.CopyUrlButton = CopyUrlButton
Toolbar.Tabs = ToolbarTabs
Toolbar.ButtonGroup = ToolbarButtonGroup
